import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "gfu-compare-row__label" }
const _hoisted_2 = {
  key: 0,
  class: "gfu-compare-row__cell-label"
}
const _hoisted_3 = { class: "gfu-compare-row__cell-text" }
const _hoisted_4 = {
  key: 0,
  class: "gfu-compare-row__cell-label"
}
const _hoisted_5 = { class: "gfu-compare-row__cell-text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.rowClasses)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "label")
    ]),
    _createElementVNode("div", {
      class: _normalizeClass($options.primaryCellClasses)
    }, [
      ($options.effectivePrimaryLabel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($options.effectivePrimaryLabel), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "primary")
      ])
    ], 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass($options.secondaryCellClasses)
    }, [
      ($options.effectiveSecondaryLabel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($options.effectiveSecondaryLabel), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "secondary")
      ])
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}